import React, { useEffect, useState } from "react";
import { authFetch } from "../../../api";

const interestIcons = {
  "STEM Explorer": "/timeline/Stem.svg",
  "Social Changemaker": "/timeline/social.svg",
  "Creative Visionary": "/timeline/creative.svg",
  Leader: "/timeline/leader.svg",
  Planner: "/timeline/organizer.svg",
};

const Timeline_ProfileBuilding = () => {
  const [options, setOptions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(null);

  const fetchOptions = async () => {
    try {
      const response = await authFetch("interest-area", {
        method: "GET",
        headers: { "content-type": "application/json" },
      });
      const data = await response.json();

      // map API response into format your UI needs
      const mapped = data.data.map((item) => ({
        label: item.interest_area,
        icon: interestIcons[item.interest_area] || "/timeline/default.svg", // fallback
        id: item.id,
      }));

      setOptions(mapped);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  return (
    <div className="mb-20 px-4 relative">
      {/* Plane at bottom-left */}
      <img
        src="/plane.png"
        alt="plane"
        className="absolute top-4 right-0  h-30 w-auto"
      />

      {/* Header Badge */}
      <div className="flex items-center justify-center my-6">
        <div className="flex-grow h-[2px] bg-gradient-to-r from-white to-[#F6E1F6] "></div>
        <div className="flex items-center gap-2 bg-[#F4DDF4] rounded-xl px-4 py-2 mx-4 border border-[#E0E0E0]">
          <img
            src="/timeline/profile-shield.svg"
            alt="shield"
            className="w-5 h-5"
          />
          <span className="text-[#F6F4FF] font-inter text-black text-[18px]">
            Profile Building
          </span>
        </div>
        <div className="flex-grow h-[2px] bg-gradient-to-l from-white to-[#F6E1F6] "></div>
      </div>

      {/* Options Grid */}
      <div className="grid grid-cols-3 gap-6 mt-6 max-w-3xl mx-auto">
        {options.map((item, index) => (
          <div
            key={item.id}
            onClick={() => setSelectedIndex(index)}
            className={`flex flex-col items-center justify-center rounded-xl p-6 text-center cursor-pointer transition 
            ${
              selectedIndex === index
                ? "border-2 border-[#572575] shadow-lg  bg-[#FBF5FF]"
                : "border  hover:shadow-md"
            }`}
          >
            <img src={item.icon} alt={item.label} className="w-12 h-12 mb-3" />
            <p
              className={`font-inter font-bold text-[16px] leading-[100%] tracking-[0px] text-center ${
                selectedIndex === index ? "text-[#9D0385]" : "text-[#444444]"
              }`}
            >
              {item.label}
            </p>
          </div>
        ))}
      </div>

      {/* Bulb at top-right */}
      <img
        src="/bulb.png"
        alt="bulb"
        className="absolute bottom-0 left-0 h-30 w-auto"
      />
    </div>
  );
};

export default Timeline_ProfileBuilding;
